export const defaultHeaders = (xhr) => {
  xhr.setRequestHeader(
    "X-CSRF-Token",
    $('meta[name="csrf-token"]').attr("content")
  );
};

export const getSearchParams = (options) => {
  const search = location.search.split('=');
  return location.search && options.includes(search[search.length-1]) ? search[search.length-1] : options[0];
};

export const updateCommunity = (
  community,
  params,
  successCallback,
  errorCallback,
  formData,
  headers = defaultHeaders
) => {

  let options = {
    beforeSend: (xhr) => headers(xhr),
    url: `${location.pathname}/${community.id}`,
    method: 'PATCH',
    data: { community: params }
  }

  if (!!formData) {
    options = { ...options, contentType: false, processData: false, data: formData }
  }

  $.ajax(options)
    .success((res) => {
      successCallback(res);
    })
    .error((err) => {
      errorCallback(err);
    })
};

export const deleteCommunity = (
  community,
  successCallback,
  errorCallback,
  headers = defaultHeaders
) => {
  let options = {
    beforeSend: (xhr) => headers(xhr),
    url: `${location.pathname}/${community.id}`,
    method: 'DELETE',
    data: {}
  }

  $.ajax(options)
    .success((res) => {
      successCallback(res);
    })
    .error((err) => {
      errorCallback(err);
    })
};

export const createCommunityInvites = (
  params,
  successCallback,
  errorCallback,
  headers = defaultHeaders
) => {
  $.ajax({
    beforeSend: (xhr) => headers(xhr),
    url: `${location.pathname.replace('members', 'invites')}`,
    method: 'POST',
    data: params
  })
    .success((res) => {
      successCallback(res);
    })
    .error((err) => {
      errorCallback(err);
    })
};

export const memberSearch = (
  params,
  successCallback,
  errorCallback,
  headers = defaultHeaders
) => {
  $.ajax({
    beforeSend: (xhr) => headers(xhr),
    url:  location.pathname,
    method: 'GET',
    data: params,
    dataType: 'json'
  })
    .success((res) => {
      successCallback(res);
    })
    .error((err) => {
      errorCallback(err);
    })
};

export const createFormData = (params, files) => {
  const formData = new FormData();
  formData.append('community[name]', params.name);
  formData.append('community[description]', params.description);
  formData.append('community[rules]', params.rules);
  formData.append('community[industries]', params.industries);
  formData.append('community[open_for_sponsorship]', params.openForSponsorship);

  if (files.length > 0) {
    formData.append('filename', files[0].name);
    formData.append('community[header_image]', files[0]);
  }

  return formData;
};
